module.exports = __webpack_public_path__ + "img/goback.a3333998.svg";